import { render, staticRenderFns } from "./indexOwnerRoom.vue?vue&type=template&id=0ac7b851&scoped=true"
import script from "./indexOwnerRoom.vue?vue&type=script&lang=js"
export * from "./indexOwnerRoom.vue?vue&type=script&lang=js"
import style0 from "./indexOwnerRoom.vue?vue&type=style&index=0&id=0ac7b851&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac7b851",
  null
  
)

export default component.exports